import _buffer from "buffer";
const {
  Buffer: _Buffer
} = _buffer;
import { decode, encode, Encoding } from "../../../utils/encoder.mjs";
export default function genEntryField(tag) {
  return {
    serialize(txParams, {
      buildTx
    }) {
      if (ArrayBuffer.isView(txParams)) return _Buffer.from(txParams);
      if (typeof txParams === 'string' && txParams.startsWith('tx_')) {
        return decode(txParams);
      }
      return decode(buildTx({
        ...txParams,
        ...(tag != null && {
          tag
        })
      }));
    },
    deserialize(buf, {
      unpackTx
    }) {
      return unpackTx(encode(buf, Encoding.Transaction), tag);
    }
  };
}
//# sourceMappingURL=entry.mjs.map